(ns common.widgets.split-button
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/ButtonGroup$default" :as ButtonGroup]
            ["@mui/material/ClickAwayListener$default" :as ClickAwayListener]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/MenuList$default" :as MenuList]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Popper$default" :as Popper]
            [mate.core :as mc]
            [uix.core :as uix :refer [$ defui]]))

(defui split-button [{:keys [options icon] :as props}]
  (let [[open set-open] (uix/use-state false)
        anchor-ref (uix/use-ref nil)
        [selected-idx set-selected-idx] (uix/use-state 0)
        selected (get-in options [selected-idx])]
    ($ :<>
       ($ ButtonGroup
          (merge {:ref anchor-ref
                  :sx #js {:boxShadow "unset"}}
                 (dissoc props :options :icon))
          ($ Button
             {:onClick (:onClick selected)
              :startIcon (when icon icon)}
             (:label selected))
          ($ Button
             {:onClick #(set-open (not open))}
             ($ Icon "arrow_drop_down")))
       ($ Popper
          {:sx #js {:zIndex 1}
           :open open
           :anchorEl @anchor-ref
           :disablePortal true}
          ($ Paper {:elevation 2}
             ($ ClickAwayListener
                {:onClickAway (fn [event]
                                (when-not (and @anchor-ref
                                               (.contains @anchor-ref (.-target event)))
                                  (set-open false)))}
                ($ MenuList {:id "split-button-menu" :autoFocusItem true}
                   (for [[idx {:keys [label]}] (mc/seq-indexed options)]
                     ($ MenuItem
                        {:key idx
                         :selected (= idx selected-idx)
                         :onClick (fn []
                                    (set-selected-idx idx)
                                    (set-open false))}
                        label)))))))))
